module.exports = __webpack_public_path__ + "img/ai2.8b17e626.png";